// import {} from '@/config/wx';
const config = {
  getSandboxPool: {
    url: '/sandbox_pool',
    server: 'sandboxServer',
    method: 'post'
  },
  getSandboxToken: {
    url: '/sandbox_storages',
    server: 'sandboxServer',
    method: 'get'
  },
  getSandboxPools: {
    url: '/sandbox_pools',
    server: 'sandboxServer',
    method: 'get'
  },
  getUserAssistance: {
    url: '/user-assistance/get',
    server: 'timelineServer',
    method: 'get'
  },
  getStorage: {
    url: '/sandbox_storages?pool_name=jupyter',
    server: 'sandboxServer',
    method: 'get'
  },

  getSandbox: {
    url: '/sandbox_pool',
    server: 'sandboxServer',
    method: 'post'
  },
  postStorageTick: {
    url: 'storage-delay-deadline',
    server: 'manageTimelineServer',
    method: 'post'
  },
  revertStorageSandbox: {
    url: '/assistance/revert-storage-sandbox',
    server: 'manageTimelineServer',
    method: 'post'
  },
  getResourceUrl: {
    url: '/url',
    server: 'originServer',
    method: 'get'
  },
  uploadResources: {
    url: '/upload',
    server: 'originServer',
    method: 'post'
  },
  profile: {
    url: '/sys/profile',
    server: 'pmsServer',
    method: 'get'
  },
  postFcSignin: {
    url: 'callback-authing/signin/v1/fc',
    server: 'fcSigninServer',
    method: 'post'
  },
  putContentPrelude: {
    url: 'entry/file/contents',
    server: '',
    method: 'put'
  }
};

export default config;
